import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import ble from './modules/ble';
import devices from './modules/devices';
import map from './modules/map';
import cluster from './modules/cluster';
import products from './modules/products';
import registerUser from './modules/registerUser';
import location from './modules/location';
import notifications from './modules/notifications';

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		auth,
		ble,
		cluster,
		devices,
		map,
		location,
		products,
		registerUser,
		notifications,
	},
	state: {
		online: true,
		isMainMenuOpen: false,
		messageIndex: 0,
	},
	actions: {
		appOnline({ commit }) {
			commit('setOnline', true);
		},
		appOffline({ commit }) {
			commit('setOnline', false);
		},
		openMainMenu({ commit }) {
			commit('isMainMenuOpen', true);
		},
		closeMainMenu({ commit }) {
			commit('isMainMenuOpen', false);
		},
		toggleMainMenu({ commit, state }) {
			commit('isMainMenuOpen', !state.isMainMenuOpen);
		},
		increaseMessageIndex({ commit }) {
			commit('increaseMessageIndex');
		},
	},
	mutations: {
		setOnline(state, value) {
			state.online = value;
		},
		isMainMenuOpen(state, value) {
			state.isMainMenuOpen = value;
		},
		increaseMessageIndex(state) {
			state.messageIndex += 1;
		},
	},
});

Vue.store = store;

export default store;
